import React, { FC } from 'react';
import styles from '../CardVisualizer/CardVisualizer.module.scss';

export type CodeProps = {
    /** It determine the cvc number */
    cvc: string;

    /** It determine wich field is focused */
    focused: string;
};

export const Code: FC<CodeProps> = (props: CodeProps) => {
    const { cvc, focused } = props;

    let className = styles['card-cvc-front'] + ' tlPrivate';

    if (focused === 'cvc') {
        className += ' ' + styles.focused;
    }

    return <div className={className}>{cvc}</div>;
};

export type ExpirationDateProps = {
    /** It determine the expiration date */
    expiry: string;

    /** It determine wich field is focused */
    focused: string;
};

export const ExpirationDate: FC<ExpirationDateProps> = (props: ExpirationDateProps) => {
    const { expiry, focused } = props;

    let className = styles['card-expiry'] + ' tlPrivate';

    if (focused === 'expiry') {
        className += ' ' + styles.focused;
    }

    if (expiry.substring(0, 1) !== '') {
        className += ' ' + styles.filled;
    }

    return <div className={className}>{expiry}</div>;
};

export type CardNumberProps = {
    /** It determine the credit card number */
    number: string;

    /** It determine wich field is focused */
    focused: string;
};

export const CardNumber: FC<CardNumberProps> = (props: CardNumberProps) => {
    const { number, focused } = props;

    let className = styles['card-number'] + ' tlPrivate';

    if (number.replace(/ /g, '').length > 16) {
        className += ' ' + styles['card-number-large'];
    }

    if (focused === 'number') {
        className += ' ' + styles.focused;
    }
    return <div className={className}>{number}</div>;
};
